module.exports = __webpack_public_path__ + "img/flutterwavelogo.50445747.png";